import classNames from 'classnames/bind';
import styles from './DrawingView.module.css';
import { useEffect, useRef } from 'react';
import useFabricCanvas from '../../../hooks/useFabricCanvas';

function Canvas({
  canvasRef,
}: {
  canvasRef: React.RefObject<HTMLCanvasElement>;
}) {
  return <canvas id="drawing" ref={canvasRef}></canvas>;
}

export default function DrawingView({ data }: any) {
  const cx = classNames.bind(styles);
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const { draw } = data;
  const { canvas } = useFabricCanvas({ canvasRef, jsonData: draw?.data });

  useEffect(() => {
    if (!canvas || !wrapperRef.current) return;

    const { clientWidth, clientHeight } = wrapperRef.current;
    canvas.setDimensions({ width: clientWidth, height: clientHeight });
  }, [canvas]);

  return (
    <div className={cx('canvas-wrapper')} ref={wrapperRef}>
      {draw && <Canvas canvasRef={canvasRef} />}
    </div>
  );
}
